export const XIcon = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0ZM18.1982 21.6689L10 30.9893H11.8525L19.0215 22.8398L24.7471 30.9893H31L22.4971 18.8877L30.3154 10H28.4629L21.6748 17.7168L16.2529 10H10L18.1982 21.6689ZM20.7002 18.8262L21.5303 19.9883L28.4639 29.6875H25.6182L19.96 21.7725L19.1299 20.6104L12.5205 11.3643H15.3662L20.7002 18.8262Z'
      fill='#292722'
    />
  </svg>
);
